import Service from "./Service"

class ProjectTaskService extends Service {

    findById = (id, nonFinishedOnly = true) => this.getWithParams(`/project-tasks/${id}`, {nonFinishedOnly})

    getSelectors = () => this.get(`/project-tasks/selectors`)

    search = (projectId, queryParams) => this.getWithParams(`/projects/${projectId}/project-tasks`, queryParams)

    createProjectTask = (projectId, requestBody) => this.post(`/projects/${projectId}/project-tasks`, requestBody)

    copyProjectTask = (requestBody) => this.put("/project-tasks", requestBody)

    updateProjectTask = (projectTaskId, requestBody) => this.patch(`/project-tasks/${projectTaskId}`, requestBody)

    deleteProjectTask = (projectTaskId) => this.del(`/project-tasks/${projectTaskId}`)
}

const projectTaskService = new ProjectTaskService()
export default projectTaskService